module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-alert-box"
  }, [_c('div', {
    class: 'callout ' + _vm.color,
    attrs: {
      "data-closable": "data-closable"
    }
  }, [_vm._t("default"), (_vm.isClosable()) ? _c('button', {
    staticClass: "close-button",
    attrs: {
      "aria-label": "Dismiss alert",
      "type": "button",
      "data-close": "data-close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3eea0fb0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/AlertBox.vue
// module id = 2431
// module chunks = 1